import Input from "components/Input";

import { ReactComponent as SearchIcon } from 'icons/components/search.svg';

export default class Search extends Input {
    getLeftIcon() {
        return <SearchIcon />;
    }
}
